/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Checkbox, message, Modal } from 'antd';

import Utils from '../../../Assets/Scripts/Utils';
import MapLocationPicker from '../../../Components/MapLocationPicker/MapLocationPicker';

function LocationOnMapModal({ isOpen, setIsOpen, onConfirm, settings }) {
  const [addressData, setAddressData] = useState(null);
  const [updateAddress, setUpdateAddress] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLocationSelect = (data) => {
    setAddressData(data);
  };

  const handleOk = async () => {
    if (!addressData) {
      message.warn('Por favor, selecione uma localização no mapa.');
      return;
    }
    setLoading(true);
    try {
      await onConfirm(addressData, updateAddress);
    } catch (error) {
      Utils.logError(error);
      message.error('Ocorreu um erro ao salvar a localização.');
    } finally {
      setLoading(false);
      setIsOpen(false);
    }
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      title="Selecionar Localização no Mapa"
      open={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      width={800}
      confirmLoading={loading}
      okText="Salvar"
      cancelText="Cancelar"
      destroyOnClose
    >
      <MapLocationPicker onLocationSelect={handleLocationSelect} height={500} settings={settings} />
      <Checkbox
        checked={updateAddress}
        onChange={(e) => setUpdateAddress(e.target.checked)}
        style={{ marginTop: 16 }}
      >
        Atualizar endereço da logística com base na localização selecionada
      </Checkbox>
    </Modal>
  );
}

export default LocationOnMapModal;
